export default "__VITE_ASSET__SrkNi2dz__"